import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { getModalControlStore } from '@/domains/header/model/store.ts'

export const useCloseMenuOnRouteChange = () => {
  const location = useLocation()

  useEffect(() => {
    getModalControlStore().closeModal()
  }, [location.pathname])
}
